import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  onSnapshot
} from "firebase/firestore";

import { db } from "../firebase";

export const subscribeProjects = (callback) => {
  const q = query(
    collection(db, "projects"),
    orderBy("createdAt", "desc")
  );

  return onSnapshot(q, (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    callback(data);
  });
};

export const createProject = async (projectData) => {
  return await addDoc(collection(db, "projects"), {
    ...projectData,
    createdAt: serverTimestamp()
  });
};

export const updateProjectById = async (id, data) => {
  return await updateDoc(doc(db, "projects", id), data);
};

export const archiveProjectById = async (id, data = {}) => {
  return await updateDoc(doc(db, "projects", id), {
    isArchived: true,
    archivedAt: serverTimestamp(),
    ...data
  });
};

export const requestProjectArchiveById = async (id, {
  reason,
  requestedBy,
  requestedByUid
}) => {
  return updateDoc(doc(db, "projects", id), {
    archiveApprovalStatus: "pending",
    archiveReason: String(reason || "").trim(),
    archiveRequestedBy: String(requestedBy || "").trim(),
    archiveRequestedByUid: String(requestedByUid || "").trim(),
    archiveRequestedAt: serverTimestamp()
  });
};

export const approveProjectArchiveById = async (id, {
  approvedBy,
  approvedByUid
}) => {
  return updateDoc(doc(db, "projects", id), {
    isArchived: true,
    archiveApprovalStatus: "approved",
    archivedAt: serverTimestamp(),
    archivedBy: String(approvedBy || "").trim(),
    archiveApprovedAt: serverTimestamp(),
    archiveApprovedBy: String(approvedBy || "").trim(),
    archiveApprovedByUid: String(approvedByUid || "").trim()
  });
};

export const rejectProjectArchiveById = async (id, {
  rejectedBy,
  rejectedByUid,
  rejectionReason
}) => {
  return updateDoc(doc(db, "projects", id), {
    isArchived: false,
    archiveApprovalStatus: "rejected",
    archiveRejectedAt: serverTimestamp(),
    archiveRejectedBy: String(rejectedBy || "").trim(),
    archiveRejectedByUid: String(rejectedByUid || "").trim(),
    archiveRejectionReason: String(rejectionReason || "").trim()
  });
};

export const deleteProjectById = async (id) => {
  return await deleteDoc(doc(db, "projects", id));
};

export const getProjectBySTB = async (stbCode) => {
  const q = query(
    collection(db, "projects"),
    where("projeStbKodu", "==", stbCode)
  );

  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const projectDoc = snapshot.docs[0];

  return {
    id: projectDoc.id,
    ...projectDoc.data()
  };
};

export const getProjectBySTBCompanyAndName = async ({
  stbCode,
  companyName,
  projectName
}) => {
  const q = query(
    collection(db, "projects"),
    where("projeStbKodu", "==", stbCode),
    where("firmaAdi", "==", companyName),
    where("projeAdi", "==", projectName)
  );

  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const projectDoc = snapshot.docs[0];

  return {
    id: projectDoc.id,
    ...projectDoc.data()
  };
};
